// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64ded3ff","455":"8bec04d1","977":"9f1e66f6"}[chunkId] + ".chunk.js";
};